import { render, staticRenderFns } from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=template&id=4a98bad3"
import script from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=script&lang=js"
export * from "./MagazzinoArticoliGiacenzaCodiciComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports